"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.fetchWithRetry = fetchWithRetry;
var MAX_RETRIES = 8;
var MAX_RETRIES_REASON = 'MAX_RETRIES';
var MAX_PAUSE = 600000;
var LTX_NO_RETRY_HEADER = 'x-lightricks-no-retry';
function setHeaders(xhr, headers) {
  Object.keys(headers).forEach(function (key) {
    xhr.setRequestHeader(key, headers[key]);
  });
}
function openAndSend(request, attempt, config, url) {
  var pause = attempt ? Math.pow(2, attempt - 1) * 1000 : 0;
  pause = pause < MAX_PAUSE ? pause : MAX_PAUSE;
  setTimeout(function () {
    request.open(config.method, url);
    if (config !== null && config !== void 0 && config.headers) {
      setHeaders(request, config.headers);
    }
    request.send(config === null || config === void 0 ? void 0 : config.body);
  }, pause);
}
function fetchWithRetry(url, config) {
  var additionalRetryStatuses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return new Promise(function (resolve, reject) {
    var attempt = 0;
    var request = new XMLHttpRequest();
    function retryOn() {
      if (attempt > MAX_RETRIES) {
        reject(MAX_RETRIES_REASON);
        return;
      }
      var isRetryAllowed = true;
      try {
        var isRetryForbiddenHeader = request.getResponseHeader(LTX_NO_RETRY_HEADER);
        if (isRetryForbiddenHeader) {
          isRetryAllowed = parseInt(isRetryForbiddenHeader, 10) !== 1;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error getting the ".concat(LTX_NO_RETRY_HEADER, " header."));
      }
      var status = request.status;
      if (isRetryAllowed && (status in additionalRetryStatuses || status >= 500)) {
        attempt += 1;
        openAndSend(request, attempt, config, url);
      }
    }
    request.onload = function () {
      if (request.status < 200 || request.status >= 300) {
        reject(this);
      } else {
        resolve(this);
      }
    };
    request.onerror = retryOn;
    request.ontimeout = retryOn;
    openAndSend(request, attempt, config, url);
  });
}
var _default = fetchWithRetry;
exports.default = _default;